export enum MarketplaceCode {
  Us = "us",
  Ca = "ca",
  Uk = "uk",
  Au = "au",
  De = "de",
}
